import { call, put, takeEvery } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IHocKyDangKy } from '../../../model/respone/lop-tin-chi/IHocKyDangKy';
import { eHocKyDangKyActionIds, IHocKyDangKyActionTypes } from "../../action-types/lop-tin-chi/IHocKyDangKyActions";
import { rootActions } from "../../actions/rootActions";
import { hocKyDangKyApi } from './../../../api/lop-tin-chi/hocKyDangKyApi';
const mainAction = rootActions.lopTinChiWrapper.kyDangKy;
export function* hocKyDangKySaga(): any {
  yield takeEvery(eHocKyDangKyActionIds.LOAD_START, loadWorker);
  yield takeEvery(eHocKyDangKyActionIds.SAVE_START, saveWorker);
  yield takeEvery(eHocKyDangKyActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(hocKyDangKyApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IHocKyDangKyActionTypes): any {
  let res: IBaseRespone;//= yield call(hocKyDangKyApi.SelectAll);
  const payload = action.payload as IHocKyDangKy;
  if (payload.ky_dang_ky > 0) {
    res = yield call(hocKyDangKyApi.Update, payload);
  } else {
    res = yield call(hocKyDangKyApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IHocKyDangKyActionTypes): any {
  const res: IBaseRespone = yield call(hocKyDangKyApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}